import React, { useEffect } from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const AddBrand = ({
  openDialog,
  handleClose,
  register,
  handleSubmit,
  errors,
  onCategoryClick,
  categoryList,
  brickList,
  onAddEditBrandSubmit,
  formData,
  brickId,
  isEditMode,
  setBrickName,
  onFamilyClick,
  productFamilyList,
  allBrands,
  setBrandName,
  onClickAddBrandButton,
  isAddBrand,
  setIsUpdateButton,
  isUpdateButton,
  setValue4,
  setBrandId,
  diableFamilyDropdown,
  diableBrickDropdown,
  setValue
}) => {
  const { content } = categoryList;

  useEffect(() => {
    register("brandId");
  }, [register]);

  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>{!isEditMode ? "Add Brand" : "Edit Brand"}</b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 2 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12}>
                      {isAddBrand || isEditMode ? (
                        <TextField
                          className="stepperFormInput"
                          label="Brand Name"
                          name="brandName"
                          placeholder="Enter brand name"
                          fullWidth
                          required
                          size="small"
                          autoComplete="off"
                          {...register("brandName", { required: true })}
                          error={Boolean(errors?.brandName)}
                          helperText={errors?.brandName?.message}
                          onChange={() => setIsUpdateButton(false)}
                          onBlur={(e) => {
                            let str = e.target.value;
                            setValue("brandName", str.trim());
                           
                          }}
                        />
                      ) : !isEditMode ? (
                        <FormControl fullWidth>
                          <InputLabel
                            id="Select-Category-label"
                            sx={{ marginTop: "-6px" }}
                          >
                            Select Brand
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Select Category"
                            name="brandId"
                            fullWidth
                            size="small"
                            defaultValue={formData.brandId}
                            autoComplete="off"
                            // {...register("brandId", { required: true })}
                            error={Boolean(errors?.brandId)}
                            helperText={errors?.brandId?.message}
                            onChange={(value) => {
                              setIsUpdateButton(false);
                              setValue4("brandName", value.target.value.name);
                              setValue4("brandId", value.target.value.brandId);
                            }}
                          >
                            {allBrands &&
                              allBrands.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.brandId}
                                    sx={{ width: "100%" }}
                                    value={d}
                                    size="small"
                                    onClick={() => {
                                      setBrandName(d.name);
                                      setBrandId(d.brandId);
                                    }}
                                  >
                                    {d.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.brandId?.message}
                          </FormHelperText>
                        </FormControl>
                      ) : null}
                      <Button onClick={() => onClickAddBrandButton(true)}>
                        {!isEditMode
                          ? !isAddBrand
                            ? "Add Brand"
                            : "Select Brand"
                          : ""}
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Select-Category-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Category
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Select Category"
                          name="categoryId"
                          fullWidth
                          size="small"
                          defaultValue={formData.categoryId}
                          autoComplete="off"
                          {...register("categoryId", { required: true })}
                          error={Boolean(errors?.categoryId)}
                          helperText={errors?.categoryId?.message}
                          onChange={() => setIsUpdateButton(false)}
                        >
                          {content &&
                            content.map((d) => {
                              return (
                                <MenuItem
                                  native
                                  key={d.categoryId}
                                  sx={{ width: "100%" }}
                                  value={d.categoryId}
                                  size="small"
                                  onClick={() =>
                                    onCategoryClick(
                                      d.categoryId,
                                      d.categoryName
                                    )
                                  }
                                >
                                  {d.categoryCode} - {d.categoryName}
                                </MenuItem>
                              );
                            })}
                        </Select>
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                          {errors && errors?.categoryId?.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Select-Category-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Product Family
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Select Product Family"
                          name="productCatFamilyMappingId"
                          fullWidth
                          size="small"
                          defaultValue={formData.productCatFamilyMappingId}
                          autoComplete="off"
                          {...register("productCatFamilyMappingId", {
                            required: true,
                          })}
                          disabled={!isEditMode && diableFamilyDropdown}
                          error={Boolean(errors?.productCatFamilyMappingId)}
                          helperText={
                            errors?.productCatFamilyMappingId?.message
                          }
                          onChange={() => setIsUpdateButton(false)}
                        >
                          {productFamilyList &&
                          productFamilyList.content &&
                          productFamilyList.content.length > 0 ? (
                            productFamilyList.content.map((d) => {
                              return (
                                <MenuItem
                                  native
                                  key={d.productCatFamilyMappingId}
                                  sx={{ width: "100%" }}
                                  value={d.productCatFamilyMappingId}
                                  size="small"
                                  onClick={() =>
                                    onFamilyClick(
                                      d.productCatFamilyMappingId,
                                      d.productFamilyName
                                    )
                                  }
                                >
                                  {d.productFamilyName}
                                </MenuItem>
                              );
                            })
                          ) : (
                            <MenuItem>Record not found</MenuItem>
                          )}
                        </Select>
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                          {errors && errors?.productCatFamilyMappingId?.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Select-Bricklabel"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Brick
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Select Brick"
                          name="brickId"
                          fullWidth
                          size="small"
                          defaultValue={brickId}
                          autoComplete="off"
                          {...register("brickId", { required: true })}
                          error={Boolean(errors?.brickId)}
                          helperText={errors?.brickId?.message}
                          disabled={!isEditMode && diableBrickDropdown}
                          onChange={() => setIsUpdateButton(false)}
                        >
                          {brickList &&
                          brickList.content &&
                          brickList.content.length > 0 ? (
                            brickList.content.map((d) => {
                              return (
                                <MenuItem
                                  native
                                  key={d.brickId}
                                  sx={{ width: "100%" }}
                                  value={d.brickId}
                                  size="small"
                                  onClick={() => setBrickName(d.brickName)}
                                >
                                  {d.brickName}
                                </MenuItem>
                              );
                            })
                          ) : (
                            <MenuItem>Record not found</MenuItem>
                          )}
                        </Select>
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                          {errors && errors?.brickId?.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 2, pl: 37 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddEditBrandSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddBrand;
